import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref, onMounted} from 'vue';
import { Listing, HoursOfOperationDisplayType } from '@truckdown/locations';
import { WorkType } from '@truckdown/servicetransactions/WorkType';
import { EquipmentType } from '@truckdown/servicetransactions/EquipmentType';

interface IProps {
    listing: Listing;

    work: WorkType;
    equipment: EquipmentType;

    hidden?: boolean;
}

interface IData {
    isVisible: Ref<boolean>;
    showRequestForm: Ref<boolean>;
}

const getData = function (props: IProps) {
    return {
        isVisible: ref<boolean>(shouldShow(props)),
        showRequestForm: ref<boolean>(props.hidden == true)
    } as IData;
}

const getComputed = function (props: IProps, data: IData) {
    return {

    };
}

const getMethods = function (props: IProps, data: IData, ctx: any) {
    return {
        openRequestForm: function () {
            data.showRequestForm.value = true;
        },

        closeRequestForm: function () {
            data.showRequestForm.value = false;
            ctx.emit('close');
        }
    };
}

const isOpen = function (listing: Listing) {
    return listing.hours.type == HoursOfOperationDisplayType.Open
        || listing.hours.type == HoursOfOperationDisplayType.AfterHours;
}

const shouldShow = function (props: IProps) {
    try {
        if (context.hasClaim('FSRDISABLED')) {
            return false;
        }

        if (props.listing.properties.type > 1
            && isOpen(props.listing)
            && props.listing.properties.canAcceptServiceRequests) {
            return true;
        }

        return false;
    }
    catch (err) {
        console.log(err);
        return false;
    }
}

export default defineComponent({
    name: "request-service-button",
    props: {
        listing: {
            type: Object as () => Listing,
            required: true
        },
        work: {
            type: Number as () => WorkType,
            default: WorkType.Repair
        },
        equipment: {
            type: Number as () => EquipmentType,
            default: EquipmentType.Truck
        },
        hidden: Boolean,
        showModal: Boolean
    },
    emits: [ 'close' ],
    setup: function (props, ctx) {
        let data = getData(props);
        let computed = getComputed(props, data);
        let methods = getMethods(props, data, ctx);

        return {
            ...data,
            ...computed,
            ...methods
        }
    }
});